/**
 *  Deprecated Feb. 17, 2021 - Please make updates in react version
 *
 */

/**
 *
 * @name app.module.HeaderDirective
 * @copyright 2015 Empower Retirement
 * @require angular
 * @description Directive responsible for the Site Header
 *
 */
import headerTemplate from "./headerTemplate";

var translateService = null;
var httpProvider = null;
var accuCodeService = null;

var HeaderDirective = function (transService, $http, AccuCodeService) {
    translateService = transService;
    httpProvider = $http;
    accuCodeService = AccuCodeService;

    var directive = {
        restrict: "E",
        controller: "HeaderController",
        scope: true,
        template: headerTemplate,
        link: initializeHeader
    };

    return directive;
};

HeaderDirective.$inject = ["translateService", "$http", "AccuCodeService"];

export default HeaderDirective;
